export default __webpack_public_path__ + "static/media/nexa-logo-white.65057ddc.png";